"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSummary = void 0;
const React = __importStar(require("react"));
const utils_1 = require("../../utils");
const kendo_react_pdf_1 = require("@progress/kendo-react-pdf");
const ZContainer_1 = require("../ZContainer/ZContainer");
const UserDefinedFields_1 = require("../../utils/userDefinedFields/UserDefinedFields");
const languages_1 = require("../../languages");
const locales_1 = require("../../locales");
const react_query_1 = require("react-query");
const useLocalizedProps_1 = require("../../languages/useLocalizedProps");
const useOrderSummaryFVS_1 = require("./useOrderSummaryFVS");
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const styled_components_1 = __importDefault(require("styled-components"));
const HeaderLabel = (props) => {
    const { languageId } = React.useContext(languages_1.llContext);
    const { label } = props;
    const LabelComponent = styled_components_1.default.div `
      font-weight: bold;
   `;
    const HeaderLabelContainer = styled_components_1.default.div `
      width: 100%;
      display: ${props.value ? "inline-block" : "none"} !important;
   `;
    const DataContainer = styled_components_1.default.span `
      ${label ? "margin-left: 5px;" : undefined}
      font-weight: normal;
   `;
    return (React.createElement(HeaderLabelContainer, { key: "HeaderLabelContainer" }, label ? (React.createElement(LabelComponent, { key: "LabelComponent" },
        `${languages_1.ll({
            key: label,
            languageId
        })}:`,
        React.createElement(DataContainer, { key: "DataContainer" }, props.value))) : (React.createElement(DataContainer, { key: "DataContainer" }, props.value))));
};
const HeaderColumn = (props) => {
    const { label } = useLocalizedProps_1.useLocalizedProps(props), Wrapper = styled_components_1.default.div `
         display: inline-block;
         width: ${props.mobile ? "100%" : "calc(100% / 3)"};
         height: 100%;
         margin-bottom: 10px;
         margin-top: 5px;
      `, Label = styled_components_1.default.span `
         display: inline-block;
         font-size: ${((props.mobile ? 2.5 : 1.25) * props.width) / 100}px;
         color: rgba(0, 0, 0, 0.6);
         width: calc(100% - 10px);
         margin-left: 10px;
         text-align: left;
      `;
    return (React.createElement(Wrapper, { key: "Wrapper" },
        React.createElement(Label, { key: "Label" }, label),
        props.children));
};
// Default Options with Allowed Styles
const SanitizeHtmlOptions = {
    ...sanitize_html_1.default.defaults,
    allowedAttributes: {
        ...sanitize_html_1.default.defaults.allowedAttributes,
        "*": ["style"]
    },
    allowedStyles: {
        "*": {
            "font-size": [/^\d+(?:px|em|%)$/],
            "text-decoration": [/^underline$/]
        }
    }
};
const OrderField = (props) => {
    const { languageId } = React.useContext(languages_1.llContext);
    const { label, value } = props;
    const Container = styled_components_1.default.div `
      display: ${value ? "inline-block" : "none"} !important;
      width: ${props.containerWidth
        ? props.containerWidth
        : props.mobile
            ? "calc(50% - 10px)"
            : "calc(25% - 10px)"};
      align-items: initial !important;
      margin: 5px 0px 5px 10px;
      vertical-align: top;
   `;
    const Label = styled_components_1.default.div `
      display: inline-block !important;
      font-size: ${((props.mobile ? 2.5 : 1.25) * props.width) / 100}px;
      color: rgba(0, 0, 0, 0.6);
      width: 100%;
   `;
    const Value = styled_components_1.default.div `
      display: inline-block !important;
      width: 100%;
   `;
    const localize = props.localize === undefined ? true : props.localize;
    return (React.createElement(Container, null,
        React.createElement(Label, null, `${localize ? languages_1.ll({ key: label, languageId }) : label}:`),
        props.isHTML ? (React.createElement(Value, { dangerouslySetInnerHTML: {
                __html: sanitize_html_1.default(value, SanitizeHtmlOptions)
            } })) : (React.createElement(Value, null, value))));
};
const isUDFTypeSupported = (type) => {
    let supportedTypes = [
        "STRING",
        "FLOAT",
        "INT",
        "ENUM",
        "DATE",
        "DATETIME",
        "TIME",
        "CHECKBOX",
        "TEXTAREA"
    ];
    return supportedTypes.includes(type);
};
exports.OrderSummary = (props) => {
    const { data, print, donePrinting, mobile, editableFVS, companyCurrency, fvsLevelData, fvsLevelId } = props, width = print ? 612 : props.width || 800, padding = width / 40, height = print ? (11 / 8.5) * width - 2 * padding : Number.MAX_VALUE, OrderSummaryContainer = styled_components_1.default.div `
         display: inline-block;
         width: ${width - 2 * padding}px;
         font-size: ${((props.mobile ? 3 : 1.5) * width) / 100}px;
         font-family: ${props => props.theme["font-family"]};
         height: ${print ? `${height}px` : "auto"};
         padding: ${padding}px;
         background-color: white;
         margin-bottom: 10px;
      `, OrderTitle = styled_components_1.default.div `
         flex-grow: 1;
         font-weight: bold;
         text-align: center;
         align-self: flex-end;
         margin: 10px;
         font-size: ${((props.mobile ? 5 : 3) * width) / 100}px;
      `, LogoContainer = styled_components_1.default.img `
         margin-left: 10px;
         margin-right: 10px;
         height: ${width / 10}px;
      `, HeaderColumnContainer = styled_components_1.default(ZContainer_1.ZContainer) `
         display: inline-block;
         vertical-align: top;
         width: calc(100% - 10px);
         margin: 0px 0px 0px 10px;
         padding: 0;

         div {
            align-items: initial;
            -webkit-box-align: initial;
            text-align: initial;
         }

         .z-container-body {
            display: inline-block !important;
            grid-template-columns: initial !important;
            grid-auto-flow: initial !important;
         }
      `, OrderFieldContainer = styled_components_1.default(ZContainer_1.ZContainer) `
         display: inline-block;
         width: 100%;
         margin: 0;
         padding: 0;

         div {
            align-items: initial;
            -webkit-box-align: initial;
            text-align: initial;
         }

         .z-container-body {
            display: inline-block !important;
            grid-template-columns: initial !important;
            grid-auto-flow: initial !important;
         }
      `, ContainerTitle = styled_components_1.default.div `
         display: inline-block;
         font-weight: bold;
         text-align: left;
         width: calc(100% - 10px);
         margin: 5px 0px 5px 10px;
      `, HeightContainer = styled_components_1.default.div `
         width: 100%;
         border-bottom: 1px solid #ccc;
      `, { localeId: contextLocale } = React.useContext(locales_1.localeContext), userLocale = props.userLocale || contextLocale, { languageId } = React.useContext(languages_1.llContext), orderUDFs = data.UserDefinedFields.filter((udf) => {
        return (udf.ShowOnDesktop &&
            udf.TableName == "Order" &&
            isUDFTypeSupported(udf.Type));
    }), appointmentUDFs = data.UserDefinedFields.filter((udf) => {
        return (udf.ShowOnDesktop &&
            udf.TableName == "Appointment" &&
            isUDFTypeSupported(udf.Type));
    }), orderSegmentUDFs = data.UserDefinedFields.filter((udf) => {
        return (udf.ShowOnDesktop &&
            udf.TableName == "OrderSegment" &&
            isUDFTypeSupported(udf.Type));
    }), orderLineUDFs = data.UserDefinedFields.filter((udf) => {
        return (udf.ShowOnDesktop &&
            udf.TableName == "OrderLine" &&
            isUDFTypeSupported(udf.Type));
    }), pdfExportRef = React.useRef(), { orderSummaryFVS } = useOrderSummaryFVS_1.useOrderSummaryFVS(print === true);
    let appointmentHeights = {}, orderSegmentHeights = {}, orderLineHeights = {}, orderNoteHeights = {}, componentList = [
        {
            type: "TitleComponent"
        },
        {
            type: "HeaderComponent"
        },
        {
            type: "OrderComponent"
        }
    ];
    data.Order.Appointment.forEach((appointment) => {
        appointmentHeights[appointment.Id] = 0;
        componentList.push({ type: "Appointment", data: appointment });
    });
    data.Order.OrderSegment.forEach((orderSegment) => {
        orderSegmentHeights[orderSegment.Id] = 0;
        componentList.push({ type: "OrderSegment", data: orderSegment });
        orderSegment.OrderLine.forEach((orderLine) => {
            orderLineHeights[orderLine.Id] = 0;
            componentList.push({ type: "OrderLine", data: orderLine });
        });
    });
    if (data.Order.OrderNote.length > 0) {
        componentList.push({
            type: "OrderNotesHeader"
        });
        data.Order.OrderNote.forEach((orderNote) => {
            orderNoteHeights[orderNote.Id] = 0;
            componentList.push({
                type: "OrderNote",
                data: orderNote
            });
        });
    }
    // The heights of the subcomponents are stored for use in determining how the component should be structured when making it printer friendly.
    let [heightState, setHeightState] = React.useState({
        titleHeight: 0,
        headerHeight: 0,
        orderHeight: 0,
        orderNoteHeaderHeight: 0,
        appointmentHeights: appointmentHeights,
        orderSegmentHeights: orderSegmentHeights,
        orderLineHeights: orderLineHeights,
        orderNoteHeights: orderNoteHeights
    });
    const titleRef = React.createRef(), headerRef = React.createRef(), orderRef = React.createRef(), orderNotesHeaderRef = React.createRef(), appointmentRefs = {}, orderSegmentRefs = {}, orderLineRefs = {}, orderNoteRefs = {};
    let containers = [], currentContainerHeight = 0, currentContainerComponents = [], newContainer = () => {
        let currentContainerRef = React.createRef();
        let currentContainer = (React.createElement(OrderSummaryContainer, { key: `OrderSummaryContainer_${containers.length}`, ref: currentContainerRef, className: containers.length > 0 ? "page-break" : undefined }, currentContainerComponents));
        containers.push(currentContainer);
        currentContainerHeight = 0;
        currentContainerComponents = [];
    };
    // This operation builds the Report.
    // It uses the height of each page to determine how many components it can fit in each page.
    componentList.forEach((component) => {
        if (component.type == "TitleComponent") {
            if (currentContainerHeight + heightState.titleHeight >= height) {
                newContainer();
            }
            currentContainerComponents.push(React.createElement(HeightContainer, { key: "TitleContainer", style: {
                    display: "flex"
                }, ref: titleRef },
                React.createElement(LogoContainer, { key: "LogoContainer", style: {
                        display: props.logoUrl ? undefined : "none !important"
                    }, src: props.logoUrl }),
                React.createElement(OrderTitle, { key: "Title" }, languages_1.ll({ key: "OrderSummaryTitle", languageId }).format(data.Order.OrderNumber))));
            currentContainerHeight += heightState.titleHeight;
        }
        else if (component.type == "HeaderComponent") {
            if (currentContainerHeight + heightState.headerHeight >= height) {
                newContainer();
            }
            currentContainerComponents.push(React.createElement(HeightContainer, { key: "HeaderContainer", ref: headerRef },
                React.createElement(HeaderColumn, { key: "CompanyContainer", width: width, label: "CompanyLiteral", mobile: mobile },
                    React.createElement(HeaderColumnContainer, { localize: false, key: "Company", id: "OrderSummaryCompany", allowedFieldStates: ["Visible", "Hidden"], editable: !print && editableFVS, numberOfColumns: 1, allowEmptySpace: false, fvsLevelData: fvsLevelData, fvsLevelId: fvsLevelId, fieldVisibilitySettings: orderSummaryFVS
                            ? {
                                components: utils_1.convertLegacyFieldVisibilitySettings(orderSummaryFVS.OrderSummaryCompany)
                            }
                            : undefined },
                        React.createElement(HeaderLabel, { key: "CompanyName", header: "CompanyName", id: "CompanyName", value: data.Company.CompanyName }),
                        React.createElement(HeaderLabel, { key: "RemitToName", header: "RemitToName", id: "RemitToName", value: data.Company.RemitToName }),
                        React.createElement(HeaderLabel, { key: "RemitToAddress1", header: "RemitToAddress1", id: "RemitToAddress1", value: data.Company.RemitToAddress1 }),
                        React.createElement(HeaderLabel, { key: "RemitToAddress2", header: "RemitToAddress2", id: "RemitToAddress2", value: data.Company.RemitToAddress2 }),
                        React.createElement(HeaderLabel, { key: "RemitToAddress3", header: "RemitToAddress3", id: "RemitToAddress3", value: data.Company.RemitToAddress3 }),
                        React.createElement(HeaderLabel, { key: "RemitToCity", header: "RemitToCity", id: "RemitToCity", value: data.Company.RemitToCity }),
                        React.createElement(HeaderLabel, { key: "RemitToRegion", header: "RemitToRegion", id: "RemitToRegion", value: data.Company.RemitToRegion }),
                        React.createElement(HeaderLabel, { key: "RemitToCountry", header: "RemitToCountry", id: "RemitToCountry", value: data.Company.RemitToCountry }))),
                React.createElement(HeaderColumn, { key: "CustomerContainer", width: width, label: "Customer", mobile: mobile },
                    React.createElement(HeaderColumnContainer, { localize: false, key: "Customer", id: "OrderSummaryCustomer", allowedFieldStates: ["Visible", "Hidden"], editable: !print && editableFVS, numberOfColumns: 1, allowEmptySpace: false, fvsLevelData: fvsLevelData, fvsLevelId: fvsLevelId, fieldVisibilitySettings: orderSummaryFVS
                            ? {
                                components: utils_1.convertLegacyFieldVisibilitySettings(orderSummaryFVS.OrderSummaryCustomer)
                            }
                            : undefined },
                        React.createElement(HeaderLabel, { key: "CustomerNumber", header: "CustomerNumber", id: "CustomerNumber", value: data.Order.Customer.CustomerNumber }),
                        React.createElement(HeaderLabel, { key: "CustomerName", header: "CustomerName", id: "CustomerName", value: data.Order.Customer.CustomerName }),
                        React.createElement(HeaderLabel, { key: "CustomerAddress1", header: "Address1", id: "Address1", value: data.Order.BillingAddress1 }),
                        React.createElement(HeaderLabel, { key: "CustomerAddress2", header: "Address2", id: "Address2", value: data.Order.BillingAddress2 }),
                        React.createElement(HeaderLabel, { key: "CustomerAddress3", header: "Address3", id: "Address3", value: data.Order.BillingAddress3 }),
                        React.createElement(HeaderLabel, { key: "CustomerCity", header: "City", id: "City", value: data.Order.BillingCity }),
                        React.createElement(HeaderLabel, { key: "CustomerRegion", header: "Region", id: "Region", value: data.Order.BillingRegion }),
                        React.createElement(HeaderLabel, { key: "CustomerCountry", header: "Country", id: "Country", value: data.Order.BillingCountry }),
                        React.createElement(HeaderLabel, { key: "CustomerPhone", header: "Phone", id: "Phone", label: "Phone", value: data.Order.BillingPhone }),
                        React.createElement(HeaderLabel, { key: "CustomerEmail", header: "Email", id: "Email", label: "Email", value: data.Order.BillingEmail }))),
                React.createElement(HeaderColumn, { key: "SiteContainer", width: width, label: "Site", mobile: mobile },
                    React.createElement(HeaderColumnContainer, { localize: false, key: "Site", id: "OrderSummarySite", allowedFieldStates: ["Visible", "Hidden"], editable: !print && editableFVS, numberOfColumns: 1, allowEmptySpace: false, fvsLevelData: fvsLevelData, fvsLevelId: fvsLevelId, fieldVisibilitySettings: orderSummaryFVS
                            ? {
                                components: utils_1.convertLegacyFieldVisibilitySettings(orderSummaryFVS.OrderSummarySite)
                            }
                            : undefined },
                        React.createElement(HeaderLabel, { key: "SiteNumber", header: "SiteNumber", id: "SiteNumber", value: data.Order.Site.SiteNumber }),
                        React.createElement(HeaderLabel, { key: "SiteName", header: "SiteName", id: "SiteName", value: data.Order.Site.SiteName }),
                        React.createElement(HeaderLabel, { key: "SiteAddress1", header: "Address1", id: "Address1", value: data.Order.SiteAddress1 }),
                        React.createElement(HeaderLabel, { key: "SiteAddress2", header: "Address2", id: "Address2", value: data.Order.SiteAddress2 }),
                        React.createElement(HeaderLabel, { key: "SiteAddress3", header: "Address3", id: "Address3", value: data.Order.SiteAddress3 }),
                        React.createElement(HeaderLabel, { key: "SiteCity", header: "City", id: "City", value: data.Order.SiteCity }),
                        React.createElement(HeaderLabel, { key: "SiteRegion", header: "Region", id: "Region", value: data.Order.SiteRegion }),
                        React.createElement(HeaderLabel, { key: "SiteCountry", header: "Country", id: "Country", value: data.Order.SiteCountry }),
                        React.createElement(HeaderLabel, { key: "SitePhone", header: "Phone", id: "Phone", label: "Phone", value: data.Order.SitePhone }),
                        React.createElement(HeaderLabel, { key: "SiteEmail", header: "Email", id: "Email", label: "Email", value: data.Order.SiteEmail })))));
            currentContainerHeight += heightState.headerHeight;
        }
        else if (component.type == "OrderComponent") {
            if (currentContainerHeight + heightState.orderHeight >= height) {
                newContainer();
            }
            currentContainerComponents.push(React.createElement(HeightContainer, { key: "OrderContainer", ref: orderRef },
                React.createElement(OrderFieldContainer, { localize: false, key: "Order", id: "OrderSummaryOrder", allowedFieldStates: ["Visible", "Hidden"], editable: !print && editableFVS, numberOfColumns: mobile ? 2 : 4, allowEmptySpace: false, fvsLevelData: fvsLevelData, fvsLevelId: fvsLevelId, fieldVisibilitySettings: orderSummaryFVS
                        ? {
                            components: utils_1.convertLegacyFieldVisibilitySettings(orderSummaryFVS.OrderSummaryOrder)
                        }
                        : undefined },
                    React.createElement(OrderField, { key: "OrderDate", label: "OrderDate", id: "OrderDate", width: width, mobile: mobile, value: React.createElement(utils_1.FormattedValue, { value: data.Order.OrderDate, format: utils_1.shortDateFormat, localeId: userLocale }) }),
                    React.createElement(OrderField, { key: "TotalPrice", label: "TotalPrice", id: "TotalPrice", width: width, mobile: mobile, value: React.createElement(utils_1.FormattedValue, { value: data.Order.TotalPrice, format: {
                                style: "currency",
                                currency: companyCurrency
                            } }) }),
                    React.createElement(OrderField, { key: "CustomerPO", label: "CustomerPO", id: "CustomerPO", width: width, mobile: mobile, value: data.Order.CustomerPO }),
                    React.createElement(OrderField, { key: "TechStatus", label: "TechStatus", id: "TechStatus", width: width, mobile: mobile, value: data.Order.TechOrderStatus }),
                    React.createElement(OrderField, { key: "OrderStatus", label: "OrderStatus", id: "OrderStatus", width: width, mobile: mobile, value: data.Order.OrderStatus.CodeNumber }),
                    React.createElement(OrderField, { key: "JobNumber", label: "JobNumber", id: "JobNumber", width: width, mobile: mobile, value: data.Order.JobNumber }),
                    React.createElement(OrderField, { key: "Reason", label: "Reason", id: "Reason", width: width, mobile: mobile, value: data.Order.Reason.CodeNumber }),
                    React.createElement(OrderField, { key: "Priority", label: "Priority", id: "Priority", width: width, mobile: mobile, value: data.Order.Priority.CodeNumber }),
                    React.createElement(OrderField, { key: "WaitingFor", label: "WaitingFor", id: "WaitingFor", width: width, mobile: mobile, value: data.Order.WaitingFor.CodeNumber }),
                    React.createElement(OrderField, { key: "Description", label: "Description", id: "Description", width: width, mobile: mobile, value: data.Order.Description }),
                    orderUDFs.map((udf) => {
                        let value = data.Order[udf.BindName];
                        return (React.createElement(OrderField, { label: udf.DisplayValue, key: `Order_${udf.BindName}`, id: udf.BindName, width: width, mobile: mobile, localize: false, value: value &&
                                UserDefinedFields_1.getUDFValue({
                                    data,
                                    localeId: userLocale,
                                    languageId,
                                    udf,
                                    value
                                }) }));
                    }))));
            currentContainerHeight += heightState.orderHeight;
        }
        else if (component.type == "Appointment") {
            if (currentContainerHeight +
                heightState.appointmentHeights[component.data.Id] >=
                height) {
                newContainer();
            }
            appointmentRefs[component.data.Id] = React.createRef();
            currentContainerComponents.push(React.createElement(HeightContainer, { key: `OrderAppointment_${component.data.Id}`, ref: appointmentRefs[component.data.Id] },
                React.createElement(ContainerTitle, null, languages_1.ll({
                    key: "OrderSummaryAppointmentTitle",
                    languageId
                }).format(component.data.AppointmentNumber, component.data.AppointmentName)),
                React.createElement(OrderFieldContainer, { localize: false, key: "Appointment", id: "OrderSummaryAppointment", allowedFieldStates: ["Visible", "Hidden"], editable: !print && editableFVS, numberOfColumns: mobile ? 2 : 4, allowEmptySpace: false, fvsLevelData: fvsLevelData, fvsLevelId: fvsLevelId, fieldVisibilitySettings: orderSummaryFVS
                        ? {
                            components: utils_1.convertLegacyFieldVisibilitySettings(orderSummaryFVS.OrderSummaryAppointment)
                        }
                        : undefined },
                    React.createElement(OrderField, { key: "PreferredTech", label: "PreferredTech", id: "PreferredTech", width: width, mobile: mobile, value: component.data.PreferredTech.ServiceTechName }),
                    React.createElement(OrderField, { key: "AssignedTech", label: "AssignedTech", id: "AssignedTech", width: width, mobile: mobile, value: component.data.AssignedTech.ServiceTechName }),
                    React.createElement(OrderField, { key: "Description", label: "Description", id: "Description", width: width, mobile: mobile, value: component.data.Description }),
                    React.createElement(OrderField, { key: "PromiseDateTime", label: "PromiseDateTime", id: "PromiseDateTime", width: width, mobile: mobile, value: component.data.PromiseDateTime && (React.createElement(utils_1.FormattedValue, { value: component.data.PromiseDateTime, format: utils_1.shortDateFormat })) }),
                    React.createElement(OrderField, { key: "ScheduledDateTime", label: "ScheduledDateTime", id: "ScheduledDateTime", width: width, mobile: mobile, value: component.data.ScheduledDateTime && (React.createElement(utils_1.FormattedValue, { value: component.data.ScheduledDateTime, format: utils_1.shortDateFormat })) }),
                    React.createElement(OrderField, { key: "ScheduledDuration", label: "ScheduledDuration", id: "ScheduledDuration", width: width, mobile: mobile, value: languages_1.ll({ key: "NHours", languageId }).format(component.data.ScheduledDuration) }),
                    React.createElement(OrderField, { key: "AppointmentStatus", label: "AppointmentStatus", id: "AppointmentStatus", width: width, mobile: mobile, value: component.data.AppointmentStatus.CodeNumber }),
                    React.createElement(OrderField, { key: "Notes", label: "Notes", id: "Notes", width: width, mobile: mobile, value: component.data.Notes && (React.createElement("pre", { style: {
                                margin: 0,
                                fontFamily: "inherit",
                                whiteSpace: "pre-wrap"
                            } }, component.data.Notes)) }),
                    React.createElement(OrderField, { key: "ClosureNotes", label: "ClosureNotes", id: "ClosureNotes", width: width, mobile: mobile, value: component.data.ClosureNotes && (React.createElement("pre", { style: {
                                margin: 0,
                                fontFamily: "inherit",
                                whiteSpace: "pre-wrap"
                            } }, component.data.ClosureNotes)) }),
                    appointmentUDFs.map((udf) => {
                        let value = component.data[udf.BindName];
                        return (React.createElement(OrderField, { label: udf.DisplayValue, key: `Appointment_${udf.BindName}`, id: udf.BindName, localize: false, width: width, mobile: mobile, value: value &&
                                UserDefinedFields_1.getUDFValue({
                                    data,
                                    localeId: userLocale,
                                    languageId,
                                    udf,
                                    value
                                }) }));
                    }))));
            currentContainerHeight +=
                heightState.appointmentHeights[component.data.Id];
        }
        else if (component.type == "OrderSegment") {
            if (currentContainerHeight +
                heightState.orderSegmentHeights[component.data.Id] >=
                height) {
                newContainer();
            }
            orderSegmentRefs[component.data.Id] =
                React.createRef();
            currentContainerComponents.push(React.createElement(HeightContainer, { key: `OrderSegment_${component.data.Id}`, ref: orderSegmentRefs[component.data.Id], style: {
                    backgroundColor: "#e6e6e6"
                } },
                React.createElement(ContainerTitle, null, languages_1.ll({
                    key: "OrderSummarySegmentTitle",
                    languageId
                }).format(component.data.SegmentNumber)),
                React.createElement(OrderFieldContainer, { localize: false, key: "OrderSegment", id: "OrderSummaryOrderSegment", allowedFieldStates: ["Visible", "Hidden"], editable: !print && editableFVS, numberOfColumns: mobile ? 2 : 4, allowEmptySpace: false, fvsLevelData: fvsLevelData, fvsLevelId: fvsLevelId, fieldVisibilitySettings: orderSummaryFVS
                        ? {
                            components: utils_1.convertLegacyFieldVisibilitySettings(orderSummaryFVS.OrderSummaryOrderSegment)
                        }
                        : undefined }, orderSegmentUDFs.map((udf) => {
                    let value = component.data[udf.BindName];
                    return (React.createElement(OrderField, { label: udf.DisplayValue, key: `OrderSegment_${udf.BindName}`, id: udf.BindName, width: width, mobile: mobile, localize: false, value: value &&
                            UserDefinedFields_1.getUDFValue({
                                data,
                                localeId: userLocale,
                                languageId,
                                udf,
                                value
                            }) }));
                }))));
            currentContainerHeight +=
                heightState.orderSegmentHeights[component.data.Id];
        }
        else if (component.type == "OrderLine") {
            if (currentContainerHeight +
                heightState.orderLineHeights[component.data.Id] >=
                height) {
                newContainer();
            }
            orderLineRefs[component.data.Id] = React.createRef();
            currentContainerComponents.push(React.createElement(HeightContainer, { key: `OrderLine_${component.data.Id}`, ref: orderLineRefs[component.data.Id] },
                React.createElement(ContainerTitle, null, languages_1.ll({
                    key: "OrderSummaryLineTitle",
                    languageId
                }).format(component.data.LineNumber)),
                React.createElement(OrderFieldContainer, { localize: false, key: "OrderLine", id: "OrderSummaryOrderLine", allowedFieldStates: ["Visible", "Hidden"], editable: !print && editableFVS, numberOfColumns: mobile ? 2 : 4, allowEmptySpace: false, fvsLevelData: fvsLevelData, fvsLevelId: fvsLevelId, fieldVisibilitySettings: orderSummaryFVS
                        ? {
                            components: utils_1.convertLegacyFieldVisibilitySettings(orderSummaryFVS.OrderSummaryOrderLine)
                        }
                        : undefined },
                    React.createElement(OrderField, { key: "ItemNumber", label: "ItemNumber", id: "ItemNumber", width: width, mobile: mobile, value: component.data.ItemNumber }),
                    React.createElement(OrderField, { key: "Description", label: "Description", id: "Description", width: width, mobile: mobile, value: component.data.Description }),
                    React.createElement(OrderField, { key: "Quantity", label: "Quantity", id: "Quantity", width: width, mobile: mobile, value: component.data.Quantity }),
                    React.createElement(OrderField, { key: "UnitPrice", label: "UnitPrice", id: "UnitPrice", width: width, mobile: mobile, value: React.createElement(utils_1.FormattedValue, { value: component.data.UnitPrice, format: {
                                style: "currency",
                                currency: companyCurrency
                            } }) }),
                    React.createElement(OrderField, { key: "ExtendedPrice", label: "ExtendedPrice", id: "ExtendedPrice", width: width, mobile: mobile, value: React.createElement(utils_1.FormattedValue, { value: component.data.ExtendedPrice, format: {
                                style: "currency",
                                currency: companyCurrency
                            } }) }),
                    React.createElement(OrderField, { key: "DiscountPercent", label: "DiscountPercent", id: "DiscountPercent", width: width, mobile: mobile, value: component.data.DiscountPercent &&
                            `${component.data.DiscountPercent}%` }),
                    orderLineUDFs.map((udf) => {
                        let value = component.data[udf.BindName];
                        return (React.createElement(OrderField, { label: udf.DisplayValue, key: `OrderLine_${udf.BindName}`, id: udf.BindName, width: width, mobile: mobile, localize: false, value: value &&
                                UserDefinedFields_1.getUDFValue({
                                    data,
                                    localeId: userLocale,
                                    languageId,
                                    udf,
                                    value
                                }) }));
                    }))));
            currentContainerHeight +=
                heightState.orderLineHeights[component.data.Id];
        }
        else if (component.type == "OrderNotesHeader") {
            if (currentContainerHeight + heightState.orderNoteHeaderHeight >=
                height) {
                newContainer();
            }
            currentContainerComponents.push(React.createElement(HeightContainer, { key: `OrderNotesHeader`, ref: orderNotesHeaderRef, style: {
                    backgroundColor: "#e6e6e6"
                } },
                React.createElement(ContainerTitle, null, languages_1.ll({
                    key: "Notes",
                    languageId
                }))));
            currentContainerHeight += heightState.orderNoteHeaderHeight;
        }
        else if (component.type == "OrderNote") {
            if (currentContainerHeight +
                heightState.orderNoteHeights[component.data.Id] >=
                height) {
                newContainer();
            }
            orderNoteRefs[component.data.Id] = React.createRef();
            currentContainerComponents.push(React.createElement(HeightContainer, { key: `OrderNote_${component.data.Id}`, ref: orderNoteRefs[component.data.Id] },
                React.createElement(OrderFieldContainer, { localize: false, key: "OrderNote", id: "OrderSummaryOrderNote", allowedFieldStates: ["Visible", "Hidden"], editable: !print && editableFVS, numberOfColumns: mobile ? 1 : 2, allowEmptySpace: false, fvsLevelData: fvsLevelData, fvsLevelId: fvsLevelId, fieldVisibilitySettings: orderSummaryFVS
                        ? {
                            components: utils_1.convertLegacyFieldVisibilitySettings(orderSummaryFVS.OrderSummaryOrderNote)
                        }
                        : undefined },
                    React.createElement(OrderField, { key: "NoteType", label: "NoteType", id: "NoteType", width: width, containerWidth: mobile ? "calc(100% - 10px)" : "calc(25% - 10px)", mobile: mobile, value: component.data.NoteType.CodeNumber }),
                    React.createElement(OrderField, { key: "Contents", label: "Contents", id: "Contents", width: width, containerWidth: mobile ? "calc(100% - 10px)" : "calc(75% - 10px)", mobile: mobile, value: component.data.Contents, isHTML: true }))));
            currentContainerHeight +=
                heightState.orderNoteHeights[component.data.Id];
        }
    });
    newContainer();
    React.useLayoutEffect(() => {
        if (print && orderSummaryFVS) {
            if (orderSummaryFVS.Error) {
                donePrinting && donePrinting();
                return;
            }
            let newHeightState = JSON.parse(JSON.stringify(heightState)), readyToPrint = true, updateHeight = (ref, stateKey) => {
                if (ref && ref.current && ref.current.clientHeight) {
                    if (ref.current.clientHeight != heightState[stateKey]) {
                        newHeightState[stateKey] = ref.current.clientHeight;
                        readyToPrint = false;
                    }
                }
                else {
                    return;
                }
            }, updateHeights = (refs, stateKey) => {
                let ids = Object.keys(refs);
                ids.forEach((key) => {
                    let ref = refs[key];
                    if (ref && ref.current && ref.current.clientHeight) {
                        if (ref.current.clientHeight != heightState[stateKey][key]) {
                            newHeightState[stateKey][key] =
                                ref.current.clientHeight;
                            readyToPrint = false;
                        }
                    }
                    else {
                        return;
                    }
                });
            };
            updateHeight(titleRef, "titleHeight");
            updateHeight(headerRef, "headerHeight");
            updateHeight(orderRef, "orderHeight");
            updateHeight(orderNotesHeaderRef, "orderNotesHeaderRef");
            updateHeights(appointmentRefs, "appointmentHeights");
            updateHeights(orderSegmentRefs, "orderSegmentHeights");
            updateHeights(orderLineRefs, "orderLineHeights");
            updateHeights(orderNoteRefs, "orderNoteHeights");
            if (readyToPrint) {
                pdfExportRef.current.save(() => {
                    donePrinting && donePrinting();
                    react_query_1.queryCache.removeQueries(["OrderSummaryFVS", { fetch: print }], {
                        exact: true
                    });
                });
            }
            else {
                setHeightState(newHeightState);
            }
        }
    }, [
        appointmentRefs,
        donePrinting,
        headerRef,
        heightState,
        orderLineRefs,
        orderNoteRefs,
        orderNotesHeaderRef,
        orderRef,
        orderSegmentRefs,
        orderSummaryFVS,
        print,
        titleRef
    ]);
    return (React.createElement(kendo_react_pdf_1.PDFExport, { ref: pdfExportRef, paperSize: "Letter", forcePageBreak: ".page-break", fileName: languages_1.ll({ key: "OrderSummaryTitle", languageId })
            .format(data.Order.OrderNumber)
            .replaceAll(" ", "_") }, containers));
};
//# sourceMappingURL=OrderSummary.js.map